import { configureStore, combineReducers } from "@reduxjs/toolkit";
import mobileReducer from "./slices/mobileSlice";
import cameraReducer from "./slices/cameraSlice";

const appReducer = combineReducers({
  mobile: mobileReducer,
  camera: cameraReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
